import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-tile',
    template: require('./app-tile.html'),
    styles: [require('./app-tile.css')],
})

export class AppTileView {
    @Input('tile-label') label: string;
    @Input('tile-route') tileRoute: string
    @Input('tile-icon') icon: string;
    @Input('tile-color') color: string;

    get imageByClass(): boolean {
        return (
            this.icon.startsWith('fa ') ||
            this.icon.startsWith('fab ') ||
            this.icon.startsWith('fas ') ||
            this.icon.startsWith('far ')
        ) ? true : false;
    }

    constructor() { }
}